/* eslint-disable */
import { Howl, Howler } from 'howler';

Howler.usingWebAudio = true;

declare var Window: any;

class AudioController {
  private prefix = process.env.PUBLIC_URL + `/audios/`;
  private hasLoad: { [k: string]: boolean } = {};

  loadConfig: { [k: string]: string[] } = {};
  private config: any[] = [
    {
      key: 'bgm',
      preload: true,
      loop: true,
      autoplay: true,
      unique: true,
    },
  ];

  private sound: { [id: string]: Howl } = {};
  private uniqueMap: {
    [k: string]: {
      id?: number;
    };
  } = {};

  constructor() {
    for (let i = 0; i < this.config.length; i++) {
      let config = this.config[i];
      let key = config.key;
      // @ts-ignore
      let src = this.prefix + `${key}.mp3`;
      this.sound[key] = new Howl({
        src: [src],
        loop: config.loop !== undefined ? config.loop : false,
        volume: config.volume !== undefined ? config.volume : 1.0,
        autoplay: config.autoPlay !== undefined ? config.autoPlay : false,
        preload: config.preload !== undefined ? config.autoPlay : false,
      });
      if (config.autoplay) {
        // 音频资源 load 之后通过微信桥接触发播放

        this.sound[key].on('load', () => {
          // if(wechat.isWechat()) {
          //   // @ts-ignore
          //   if (typeof window !== 'undefined') {
          //     // @ts-ignore
          //     window.WeixinJSBridge && window.WeixinJSBridge.invoke('getNetworkType', {},  ()=> {
          //       this.sound[key].play();
          //     }, false);
          //   }
          // } else {
          // document.addEventListener(
          //   'pointerdown',
          //   () => {
          //     if (this.playing(key)) return;
          //     this.sound[key].play();
          //   },
          //   { once: true }
          // );
          // }
        });
      }
      this.sound[key].load();
      if (config.unique) {
        this.uniqueMap[key] = {
          id: undefined,
        };
      }
    }

    // @ts-ignore
    if (typeof window !== 'undefined') {
      // @ts-ignore
      window.addEventListener('visibilitychange', () => {
        if (document.hidden) {
          this.pauseAllSound();
        } else {
          this.resumeAllSound();
        }
      });
    }
  }

  tempPauseList: string[] = [];
  pauseAllSound() {
    const keys = Object.keys(this.sound);
    this.tempPauseList = [];
    keys.forEach(k => {
      const s = this.sound[k];
      if (s.playing()) {
        this.tempPauseList.push(k);
        s.pause();
      }
    });
  }
  resumeAllSound() {
    this.tempPauseList.forEach(k => {
      const s = this.sound[k];
      try {
        s.play();
      } catch (e) {
        console.log(e);
      }
    });
  }

  load(name: string) {
    if (this.hasLoad[name]) return;
    const arr = this.loadConfig[name];
    if (arr) {
      arr.forEach(soundKey => {
        this.sound[soundKey]?.load();
      });
    }
    this.hasLoad[name] = true;
  }

  unload(name: string) {
    if (!this.hasLoad[name]) return;
    const arr = this.loadConfig[name];
    if (arr) {
      arr.forEach(soundKey => {
        this.sound[soundKey]?.unload();
      });
    }
    this.hasLoad[name] = false;
  }

  isUnique(key: string) {
    return this.uniqueMap[key] ? true : false;
  }

  getId(key: string) {
    const isUnique = this.isUnique(key);
    return isUnique ? this.uniqueMap[key].id : undefined;
  }

  play(key: string, startTime = 0) {
    if (this.sound.hasOwnProperty(key)) {
      const sound = this.sound[key];
      const isUnique = this.isUnique(key);
      const soundId = this.getId(key);

      if (sound.playing(soundId)) {
        this.stop(key);
      }
      sound.seek(startTime);
      const id = sound.play(soundId);

      // 存储唯一id
      if (isUnique && soundId === undefined) {
        this.uniqueMap[key].id = id;
      }
    }
  }

  playing(key: string) {
    if (this.sound.hasOwnProperty(key)) {
      const sound = this.sound[key];
      const soundId = this.getId(key);
      return sound.playing(soundId);
    }
    return false;
  }

  volume(key: string, v: number) {
    if (this.sound.hasOwnProperty(key)) {
      this.sound[key].volume(v);
    }
  }

  fadeIn(key: string) {
    if (this.sound.hasOwnProperty(key)) {
      const sound = this.sound[key];
      const soundId = this.getId(key);

      if (sound.playing(soundId)) return;
      sound.fade(0, 1, 1000, soundId);
      this.play(key);
    }
  }
  // fadeOut(key: string) {
  //   console.log('fadeOut', key)
  //   if (this.sound.hasOwnProperty(key)) {
  //     const sound = this.sound[key];
  //     const soundId = this.getId(key)

  //     sound.once('fade', () => { console.log("stop", key); sound.stop() })
  //     this.sound[key].fade(1, 0, 1000, soundId);
  //   }
  // }
  getCurrentTime(key: string) {
    if (this.sound.hasOwnProperty(key)) {
      const sound = this.sound[key];
      const soundId = this.getId(key);
      return sound.seek();
    }
    return 0;
  }
  getDuration(key: string) {
    if (this.sound.hasOwnProperty(key)) {
      const sound = this.sound[key];
      const soundId = this.getId(key);
      return sound.duration(soundId);
    }
    return 0;
  }
  pause(key: string) {
    if (this.sound.hasOwnProperty(key)) {
      const sound = this.sound[key];
      const soundId = this.getId(key);
      sound.pause(soundId);
    }
  }
  stop(key: string) {
    if (this.sound.hasOwnProperty(key)) {
      const sound = this.sound[key];
      const soundId = this.getId(key);
      sound.stop(soundId);
    }
  }
  enabled = true;
  setEnabled(enabled: boolean) {
    if (enabled) {
      Howler.volume(1);
    } else {
      Howler.volume(0);
    }
    this.enabled = enabled;
  }
}
const audioController = new AudioController();
export default audioController;
